module.exports = __webpack_public_path__ + "img/bluesky3100_05.9b47d4a0.jpg";